import { useIntl } from "react-intl";
import { InfoTooltip } from "@/components/design/InfoTooltip";
import { classificationForText } from "@/lib/esco";

/** Part of the entry display, so an authorized viewer sees the same confirmed mappings as its owner. */
export function EscoReferences({ value, text }: { value: unknown; text: string }) {
  const intl = useIntl();
  const refs = classificationForText(value, text)?.references.filter(r => r.status === "CONFIRMED"
    && /^http:\/\/data\.europa\.eu\/esco\/occupation\/[0-9a-f-]{36}$/.test(r.uri)) ?? [];
  if (!refs.length) return null;
  return <div className="mt-1 flex flex-wrap gap-x-3 gap-y-1 smycles-field-meta text-ink-muted">
    {refs.map(ref => <span key={ref.uri} className="inline-flex max-w-full items-center gap-1.5"
      onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
      <a href={ref.uri} target="_blank" rel="noreferrer"
        className="min-w-0 break-words underline decoration-ink-ui/40 underline-offset-2 hover:text-ink-accent">
        ESCO · {ref.label}
      </a>
      {ref.description?.trim() ? <InfoTooltip
        ariaLabel={`${intl.formatMessage({ id: "esco.details", defaultMessage: "Description" })}: ${ref.label}`}
        title={`ESCO · ${ref.label}`} placement="bottom" className="shrink-0">
        <span className="block max-h-64 overflow-y-auto whitespace-pre-line break-words">{ref.description}</span>
      </InfoTooltip> : null}
    </span>)}
  </div>;
}
